import { z } from 'zod';

const VideoSchema = z.object({
    url: z.string(),
    description: z.string().optional().nullable(),
    id: z.string().optional().nullable(),
});

export { VideoSchema };
